var map = {
	"./restaurant1.jpg": 3296,
	"./restaurant10.jpg": 4754,
	"./restaurant11.jpg": 1107,
	"./restaurant12.jpg": 8096,
	"./restaurant13.jpg": 1696,
	"./restaurant14.jpg": 5557,
	"./restaurant15.jpg": 109,
	"./restaurant16.jpg": 5528,
	"./restaurant2.jpg": 7146,
	"./restaurant3.jpg": 6831,
	"./restaurant4.jpg": 6381,
	"./restaurant5.jpg": 9235,
	"./restaurant6.jpg": 9439,
	"./restaurant7.jpg": 9026,
	"./restaurant8.jpg": 7868,
	"./restaurant9.jpg": 825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4151;